import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NavigationModule } from '../navigation/navigation.module';
import { SummaryModule } from '../summary/summary.module';
import { TopicPaneComponent } from './topicPane.component';
import { MoreLikeThisComponent } from './moreLikeThis.component';
import { PipesModule } from '../pipes/pipes.module';
import { ItemViewerComponent } from './itemViewer.component';
import { ItemPostComponent } from './itemPost.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        FlexLayoutModule,
        FormsModule,
        GeneralModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        MomentModule,
        NavigationModule,
        PipesModule,
        RouterModule,
        InfiniteScrollModule,
        SummaryModule
    ],
    declarations: [
        ItemPostComponent,
        ItemViewerComponent,
        MoreLikeThisComponent,
        TopicPaneComponent
    ],
    exports: [
        ItemPostComponent,
        ItemViewerComponent,
        TopicPaneComponent
    ]
})
export class ReadingModule {
}